import { FC } from 'react';
import { CgClose } from 'react-icons/cg';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';

import { UploadedFileTileProps } from './types';

export const UploadedFileTile: FC<UploadedFileTileProps> = ({
  file,
  onRemove,
}) => (
  <Flex
    alignItems="center"
    bg="gray.25"
    borderWidth="1px"
    justifyContent="space-between"
    minH={20}
    mt={2.5}
    p={4}
    position="relative"
  >
    <Box>
      <Text>{file.name}</Text>

      <Text color="gray.700" fontSize="sm">
        {(file.size / 1_000_000).toFixed(2)} MB
      </Text>
    </Box>

    <Box as="button" ml={6} onClick={onRemove}>
      <Icon as={CgClose} boxSize={6} />
    </Box>
  </Flex>
);
